enum ElementType {
    COLUMN = 'column',
    PAGE = 'page',
    ELEMENT = 'element',
}

export default ElementType;
